import { TransitionStartEvent, TransitionEndEvent, EnterAnimationStartEvent } from '@gob/events'
import Swup from 'swup'

class PageTransition {
  constructor() {
    this.init();
  }

  init() {
    this.swup = new Swup({
      containers: ['#main']
    })

    this.swup.hooks.on('visit:start', () => {
      window.dispatchEvent(new TransitionStartEvent())
    })

    this.swup.hooks.on('visit:end', () => {
      window.dispatchEvent(new TransitionEndEvent())
    })

    this.swup.hooks.on('animation:in:start', () => {
      window.dispatchEvent(new EnterAnimationStartEvent())

    })
  }
}

const pageTransition = new PageTransition()

export default pageTransition